import { useMeasure } from "react-use";
import { AccountWidgetCircle, Wrapper } from "./accountWidget.styles";
import cx from "classnames";
import { AccountDescription } from "./accountDescription";
import React from "react";
import PropTypes from "prop-types";

export const CircleContentContainer = props => {
  const { children, arrears, accountDescription, accountType, className, style } = props
  const [ref, { width }] = useMeasure();

  return (
    <Wrapper style={style} className={cx("account-widget", className)}>
      <AccountWidgetCircle ref={ref} style={{ minHeight: width }}>
        <div className={cx("outer-circle", { "red-border": arrears })}>
          <AccountDescription
            accountDescription={accountDescription}
            accountType={accountType}
            red={arrears}
          />
        </div>
        <div className="inner-circle">
          {children}
        </div>
      </AccountWidgetCircle>
    </Wrapper>
  );
};

CircleContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
  arrears: PropTypes.bool,
  accountDescription: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

CircleContentContainer.defaultProps = {
  arrears: false,
  className: undefined,
  style: undefined,
};
